import { Component, Input, OnInit, Output,EventEmitter,SimpleChanges, ViewChild, OnChanges, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { DistributionListCluster } from 'app/views/campaign-3/models/campaign-3.model';

@Component({
  selector: 'app-campaign-3-search-distribution-list',
  templateUrl: './campaign-3-search-distribution-list.component.html',
  styleUrls: ['./campaign-3-search-distribution-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchDistributionListComponent implements OnInit {
  
  @Output() distributionListSelected: EventEmitter<DistributionListCluster> = new EventEmitter<DistributionListCluster>();

  @Input() distributionList: Array<DistributionListCluster>;
  
  paginationType: number = Campaign3KontableComponent.NoPagination;
  show = {
    table: false
  }
  
  constructor(

    ) {
  
  }
  ngOnInit() {
    
    this.show.table = true;
  
  }
  onDistributionListSelected(distrList: DistributionListCluster){
    if(distrList)
      this.distributionListSelected.emit(distrList);
    else this.distributionListSelected.emit(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-distribution-list/campaign-3-search-distribution-list.component.ts